module.exports = __webpack_public_path__ + "static/media/cert7.b0dea05f.png";